import { IStackProps, Stack, Spinner, SpinnerSize } from "@fluentui/react";
import { Component } from "react";
import "./Loader.scss";
import classNames from "classnames";

interface IProps {
    loaderSize?: loaderSize;
    inline?: boolean;
}

class SpintrLoader extends Component<IProps> {
    public static defaultProps: IProps = {
        loaderSize: "large",
    };

    render() {
        const rowProps: IStackProps = { horizontal: true, verticalAlign: "center" };

        const tokens = {
            spinnerStack: {
                childrenGap: 20,
            },
        };

        const size =
            this.props.loaderSize === "xSmall"
                ? SpinnerSize.xSmall
                : this.props.loaderSize === "small"
                ? SpinnerSize.small
                : this.props.loaderSize === "medium"
                ? SpinnerSize.medium
                : SpinnerSize.large;

        return (
            <div className={classNames("SpintrLoader", { "SpintrLoader--inline": this.props.inline })}>
                <Stack {...rowProps} tokens={tokens.spinnerStack}>
                    <Spinner size={size} />
                </Stack>
            </div>
        );
    }
}

export default SpintrLoader;
